export default __webpack_public_path__ + "static/media/lip-1.afbe7961.PNG";